import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { Download, Filter, Search, TrendingUp } from 'lucide-react';
const usageData = [{
  name: 'Item A',
  usage: 120,
  cost: 450
}, {
  name: 'Item B',
  usage: 85,
  cost: 1200
}, {
  name: 'Item C',
  usage: 240,
  cost: 320
}, {
  name: 'Item D',
  usage: 45,
  cost: 850
}, {
  name: 'Item E',
  usage: 110,
  cost: 540
}];
export function UsageReport() {
  return <div className="space-y-6" data-id="element-1102">
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4" data-id="element-1103">
        <div data-id="element-1104">
          <h3 className="text-xl font-black text-slate-900" data-id="element-1105">
            Usage & Consumption
          </h3>
          <p className="text-sm font-bold text-slate-500" data-id="element-1106">
            Track item velocity and consumption patterns
          </p>
        </div>
        <div className="flex items-center gap-2" data-id="element-1107">
          <button className="flex items-center gap-2 px-4 py-2 bg-white border border-slate-200 rounded-xl text-sm font-bold text-slate-600 hover:bg-slate-50 transition-all shadow-sm" data-id="element-1108">
            <Filter size={16} data-id="element-1109" />
            Filters
          </button>
          <button className="flex items-center gap-2 px-4 py-2 bg-emerald-500 text-white rounded-xl text-sm font-bold hover:bg-emerald-600 transition-all shadow-lg shadow-emerald-500/20" data-id="element-1110">
            <TrendingUp size={16} data-id="element-1111" />
            Update PAR Recs
          </button>
        </div>
      </div>

      <div className="bg-white p-6 rounded-2xl border border-slate-100 shadow-sm" data-id="element-1112">
        <h4 className="text-sm font-bold text-slate-400 uppercase tracking-wider mb-8" data-id="element-1113">
          Usage Velocity (Units)
        </h4>
        <div className="h-64 w-full" data-id="element-1114">
          <ResponsiveContainer width="100%" height="100%" data-id="element-1115">
            <BarChart data={usageData} data-id="element-1116">
              <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#F1F5F9" data-id="element-1117" />
              <XAxis dataKey="name" axisLine={false} tickLine={false} tick={{
              fontSize: 10,
              fontWeight: 700,
              fill: '#94A3B8'
            }} data-id="element-1118" />
              <YAxis axisLine={false} tickLine={false} tick={{
              fontSize: 10,
              fontWeight: 700,
              fill: '#94A3B8'
            }} data-id="element-1119" />
              <Tooltip contentStyle={{
              borderRadius: '12px',
              border: 'none',
              boxShadow: '0 10px 15px -3px rgb(0 0 0 / 0.1)'
            }} data-id="element-1120" />
              <Bar dataKey="usage" fill="#6366F1" radius={[4, 4, 0, 0]} barSize={32} data-id="element-1121" />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>

      <div className="bg-white rounded-2xl border border-slate-100 shadow-sm overflow-hidden" data-id="element-1122">
        <div className="overflow-x-auto" data-id="element-1123">
          <table className="w-full text-left border-collapse" data-id="element-1124">
            <thead data-id="element-1125">
              <tr className="bg-slate-50/50 border-b border-slate-100" data-id="element-1126">
                <th className="px-6 py-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-1127">
                  Item
                </th>
                <th className="px-6 py-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest text-center" data-id="element-1128">
                  Starting Qty
                </th>
                <th className="px-6 py-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest text-center" data-id="element-1129">
                  Ending Qty
                </th>
                <th className="px-6 py-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest text-center" data-id="element-1130">
                  Usage
                </th>
                <th className="px-6 py-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest text-right" data-id="element-1131">
                  Usage $
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-50" data-id="element-1132">
              {[1, 2, 3, 4, 5].map(i => <tr key={i} className="hover:bg-slate-50/50 transition-colors" data-id="element-1133">
                  <td className="px-6 py-4" data-id="element-1134">
                    <p className="text-sm font-bold text-slate-900" data-id="element-1135">
                      Usage Item {i}
                    </p>
                    <p className="text-[10px] text-slate-400 font-medium uppercase tracking-wider" data-id="element-1136">
                      Food Master
                    </p>
                  </td>
                  <td className="px-6 py-4 text-center text-sm font-bold text-slate-500" data-id="element-1137">
                    100
                  </td>
                  <td className="px-6 py-4 text-center text-sm font-bold text-slate-500" data-id="element-1138">
                    20
                  </td>
                  <td className="px-6 py-4 text-center" data-id="element-1139">
                    <span className="text-sm font-black text-slate-900" data-id="element-1140">
                      80
                    </span>
                  </td>
                  <td className="px-6 py-4 text-right text-sm font-black text-emerald-600" data-id="element-1141">
                    $1,240.00
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </div>;
}